import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const courier = {
  courierList: params => {
    const url = api.courier.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createCourier: payloads => {
    const url = api.courier.list
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  courierDetail: courierId => {
    const url = api.courier.detail(courierId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  balanceList: params => {
    const url = api.courier.balance + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  }
}
export default courier
